import { Injectable, inject } from "@angular/core";
import { BenefitsService } from "src/app/services/benefits.service";
import { ConsentService } from "src/app/services/consent.service";
import { ClientDataService } from "src/app/services/customer-supplied-data/client-data.service";
import { ProfileService } from "src/app/services/customer-supplied-data/profile.service";
import { CustomerService } from "src/app/services/customer.service";
import { AfpService } from "src/app/services/prognoses-services/afp.service";
import { BankService } from "src/app/services/prognoses-services/bank.service";
import { ExternalEngagementsService } from "src/app/services/prognoses-services/external-engagements.service";
import { NorskpensjonService } from "src/app/services/prognoses-services/norskpensjon.service";

export interface DevFetchAction {
  /** Stable id, kebab-case. */
  readonly id: string;
  /** Button label shown in the dev panel; also what the panel's filter box matches on. */
  readonly label: string;
  /** Extra search aliases for the dev panel filter (e.g. ["engagements"] for afp). */
  readonly keywords: readonly string[];
  readonly run: () => void;
}

@Injectable({ providedIn: "root" })
export class DevFetchActionsService {
  private readonly afpService = inject(AfpService);
  private readonly bankService = inject(BankService);
  private readonly externalEngagementsService = inject(ExternalEngagementsService);
  private readonly npService = inject(NorskpensjonService);
  private readonly consentService = inject(ConsentService);
  private readonly customerService = inject(CustomerService);
  private readonly profileService = inject(ProfileService);
  private readonly clientDataService = inject(ClientDataService);
  private readonly benefitsService = inject(BenefitsService);

  readonly actions: readonly DevFetchAction[] = [
    {
      id: "afp",
      label: "Fetch AFP engagements",
      keywords: ["engagements", "fetch", "afp"],
      run: (): void => {
        this.afpService.fetchEngagements().subscribe();
      },
    },
    {
      id: "bank",
      label: "Fetch bank engagements",
      keywords: ["engagements", "fetch", "bank"],
      run: (): void => {
        this.bankService.fetchEngagements().subscribe();
      },
    },
    {
      id: "external",
      label: "Fetch external engagements",
      keywords: ["engagements", "fetch", "external"],
      run: (): void => {
        this.externalEngagementsService.fetchEngagements().subscribe();
      },
    },
    {
      id: "norskpensjon",
      label: "Fetch Norsk Pensjon engagements",
      keywords: ["np", "engagements", "fetch", "norskpensjon"],
      run: (): void => {
        this.npService.fetchEngagements().subscribe();
      },
    },
    {
      id: "consent-rest-api",
      label: "Fetch consents",
      keywords: ["consent", "fetch", "consent-rest-api"],
      run: (): void => {
        this.consentService.fetchConsents().subscribe();
      },
    },
    {
      id: "customer-rest-api",
      label: "Fetch customer",
      keywords: ["customer", "fetch", "customer-rest-api"],
      run: (): void => {
        this.customerService.fetchAndSetCustomerWithLoader().subscribe();
      },
    },
    {
      id: "profile",
      label: "Fetch profile",
      keywords: ["customer supplied", "fetch", "profile"],
      run: (): void => {
        this.profileService.fetchProfile().subscribe();
      },
    },
    {
      id: "supplied-data",
      label: "Fetch supplied data",
      keywords: ["clientdata", "customer supplied", "fetch", "supplied-data"],
      run: (): void => {
        this.clientDataService.fetchClientDataWrapper().subscribe();
      },
    },
    {
      id: "benefits-rest-api",
      label: "Fetch benefits",
      keywords: ["benefits", "fetch", "benefits-rest-api"],
      run: (): void => {
        this.benefitsService.fetchCustomerBenefits();
      },
    },
  ];
}
